module.exports = __webpack_public_path__ + "img/tm6.debcffd6.jpg";